export default __webpack_public_path__ + "static/media/58.b58adb33.png";